import { isDevelopment } from '@activebrands/core-web/utils/constants';

const getCookiePath = () => {
    return isDevelopment ? '/' : `/${process.env.REACT_APP_PREFIX}`;
};

export default getCookiePath;
